import { relativeTimeFormat } from './intl-cache';

const SECOND = 1_000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export const formatRelativeTime = (iso: string, locale: string, now = Date.now()): string => {
  const elapsed = Math.max(now - Date.parse(iso), 0);
  const format = relativeTimeFormat(locale, { numeric: 'auto' });
  if (elapsed < MINUTE) return format.format(0, 'second');
  if (elapsed < HOUR) return format.format(-Math.floor(elapsed / MINUTE), 'minute');
  if (elapsed < DAY) return format.format(-Math.floor(elapsed / HOUR), 'hour');
  return format.format(-Math.floor(elapsed / DAY), 'day');
};
